import { Box, BoxProps } from '@mui/material';
import { forwardRef } from 'react';

export interface MicrospecSvgIconProps extends Omit<BoxProps, 'component'> {
    /**
     * The source path of the SVG file
     */
    src: string;
    /**
     * Width of the SVG icon (default: 24px)
     */
    width?: number | string;
    /**
     * Height of the SVG icon (default: 24px)
     */
    height?: number | string;
}

/**
 * Component that renders an SVG file from a source path.
 * Preserves the original SVG colors and styling.
 */
const MicrospecSvgIcon = forwardRef<HTMLSpanElement, MicrospecSvgIconProps>(
    ({ src, width = 24, height = 24, sx, ...other }, ref) => (
        <Box
            component="span"
            className="microspec-svg-icon"
            ref={ref}
            sx={{
                width,
                height,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}
            {...other}
        >
            <Box
                component="img"
                src={src}
                alt=""
                sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                }}
            />
        </Box>
    )
);

MicrospecSvgIcon.displayName = 'MicrospecSvgIcon';

export default MicrospecSvgIcon;
